import React from 'react';

import PasswordInput from './index';

export default {
    title: 'Example/PasswordInput',
    component: PasswordInput,
};

const Template = function Template(args) {
    return (
        <PasswordInput {...args}>
            <span />
            <input className="input text-box single-line password is-white passwordInput" type="password" name="Password" value="" />
        </PasswordInput>
    );
};

export const Primary = Template.bind({});
Primary.args = {
    label: 'Password',
};
